// Reset demo (TOM-892, cloud ADR 0436): the banner's Reset demo. After a plain
// confirm it sends `POST /v1/demo/reset`, which keeps the visitor's boat under
// a fresh guest session, copies the demo template back and sends the boat to
// the start of day 3's history at the current time of day. The page then loads
// again from the boat's home, so nothing from before the reset stays on screen.

import { useCallback, useState } from 'react';

import { api } from '../api';
import { boatPath } from '../components/app/shellNav';
import { browserTimeZone, DEMO_RESET_CONFIRM, markDemoResetting } from './demo';

interface ResetResponse {
  boatId: string;
  expiresAt: string;
}

export function useResetDemo(): {
  reset: () => Promise<void>;
  busy: boolean;
  failed: boolean;
} {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const reset = useCallback(async () => {
    if (!window.confirm(DEMO_RESET_CONFIRM)) return;
    setBusy(true);
    setFailed(false);
    // The old guest's requests in flight get 401 once it is erased: not an ended lease.
    markDemoResetting(true);
    try {
      const timeZone = browserTimeZone();
      const res = await api<ResetResponse>('/v1/demo/reset', {
        method: 'POST',
        body: timeZone === undefined ? {} : { timeZone },
      });
      window.location.assign(boatPath(res.boatId, ''));
    } catch {
      markDemoResetting(false);
      setBusy(false);
      setFailed(true);
    }
  }, []);
  return { reset, busy, failed };
}
